// @ts-check
import logo from "./manifest/horizon/logo.js";
import illustration from "./manifest/horizon/illustration.js";

/** @type import("../types/images").ImageTheme */
export default {
  name: "Horizon Images",
  logo,
  illustration,
};
